module.exports.Stickers = {
  'standard': {
    premium: false,
    stickers: [{
      image: 'check',
      url: require('resources/images/stickers/check.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/check.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/check@2x.png') }
      ]
    }
    , {
      image: 'heart',
      url: require('resources/images/stickers/heart.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/heart.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/heart@2x.png') }
      ]
    }
    , {
      image: 'warning',
      url: require('resources/images/stickers/warning.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/warning.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/warning@2x.png') }
      ]
    }
    , {
      image: 'clock',
      url: require('resources/images/stickers/clock.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/clock.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/clock@2x.png') }
      ]
    }
    , {
      image: 'smile',
      url: require('resources/images/stickers/smile.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/smile.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/smile@2x.png') }
      ]
    }
    , {
      image: 'laugh',
      url: require('resources/images/stickers/laugh.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/laugh.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/laugh@2x.png') }
      ]
    }
    , {
      image: 'huh',
      url: require('resources/images/stickers/huh.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/huh.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/huh@2x.png') }
      ]
    }
    , {
      image: 'frown',
      url: require('resources/images/stickers/frown.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/frown.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/frown@2x.png') }
      ]
    }
    , {
      image: 'thumbsup',
      url: require('resources/images/stickers/thumbsup.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/thumbsup.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/thumbsup@2x.png') }
      ]
    }
    , {
      image: 'thumbsdown',
      url: require('resources/images/stickers/thumbsdown.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/thumbsdown.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/thumbsdown@2x.png') }
        ]
    }
    , {
      image: 'star',
      url: require('resources/images/stickers/star.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/star.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/star@2x.png') }
      ]
    }
    , {
      image: 'rocketship',
      url: require('resources/images/stickers/rocketship.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/rocketship.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/rocketship@2x.png') }
        ]
    }
    ]
  },

  'taco': {
    premium: true,
    stickers: [{
      image: 'taco-love',
      url: require('resources/images/stickers/taco-love.png'),
      scaled: [
        { width: 140, height: 140, url: require('resources/images/stickers/taco-love.png') },
        { width: 280, height: 280, url: require('resources/images/stickers/taco-love@2x.png') }
      ]
    }
    , {
      image: 'taco-confused',
      url: require('resources/images/stickers/taco-confused.png'),
      scaled: [
        { width: 140, height: 140, url: require('resources/images/stickers/taco-confused.png') },
        { width: 280, height: 280, url: require('resources/images/stickers/taco-confused@2x.png') }
        ]
    }
    , {
      image: 'taco-cool',
      url: require('resources/images/stickers/taco-cool.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/taco-cool.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/taco-cool@2x.png') }
      ]
    }
    , {
      image: 'taco-angry',
      url: require('resources/images/stickers/taco-angry.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/taco-angry.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/taco-angry@2x.png') }
        ]
    }
    , {
      image: 'taco-celebrate',
      url: require('resources/images/stickers/taco-celebrate.png'),
      scaled: [
        { width: 140, height: 140, url: require('resources/images/stickers/taco-celebrate.png') },
        { width: 280, height: 280, url: require('resources/images/stickers/taco-celebrate@2x.png') }
        ]
    }
    , {
      image: 'taco-robot',
      url: require('resources/images/stickers/taco-robot.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/taco-robot.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/taco-robot@2x.png') }
        ]
    }
    , {
      image: 'taco-alert',
      url: require('resources/images/stickers/taco-alert.png'),
      scaled: [
        { width: 140, height: 140, url: require('resources/images/stickers/taco-alert.png') },
        { width: 280, height: 280, url: require('resources/images/stickers/taco-alert@2x.png') }
        ]
    }
    , {
      image: 'taco-active',
      url: require('resources/images/stickers/taco-active.png'),
      scaled: [
        { width: 140, height: 140, url: require('resources/images/stickers/taco-active.png') },
        { width: 280, height: 280, url: require('resources/images/stickers/taco-active@2x.png') }
        ]
    }
    , {
      image: 'taco-money',
      url: require('resources/images/stickers/taco-money.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/taco-money.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/taco-money@2x.png') }
        ]
    }
    , {
      image: 'taco-reading',
      url: require('resources/images/stickers/taco-reading.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/taco-reading.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/taco-reading@2x.png') }
        ]
    }
    , {
      image: 'taco-trophy',
      url: require('resources/images/stickers/taco-trophy.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/taco-trophy.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/taco-trophy@2x.png') }
        ]
    }
    , {
      image: 'taco-sleeping',
      url: require('resources/images/stickers/taco-sleeping.png'),
      scaled: [
        { width: 140, height: 140, url: require('resources/images/stickers/taco-sleeping.png') },
        { width: 280, height: 280, url: require('resources/images/stickers/taco-sleeping@2x.png') }
        ]
    }
    , {
      image: 'taco-pixel',
      url: require('resources/images/stickers/taco-pixel.png'),
      scaled: [
        { width: 140, height: 140, url: require('resources/images/stickers/taco-pixel.png') },
        { width: 280, height: 280, url: require('resources/images/stickers/taco-pixel@2x.png') }
        ]
    }
    , {
      image: 'taco-proto',
      url: require('resources/images/stickers/taco-proto.png'),
      scaled: [
        { width: 140, height: 140, url: require('resources/images/stickers/taco-proto.png') },
        { width: 280, height: 280, url: require('resources/images/stickers/taco-proto@2x.png') }
        ]
    }
    , {
      image: 'taco-embarrassed',
      url: require('resources/images/stickers/taco-embarrassed.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/taco-embarrassed.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/taco-embarrassed@2x.png') }
        ]
    }
    , {
      image: 'taco-clean',
      url: require('resources/images/stickers/taco-clean.png'),
      scaled: [
        { width: 140, height: 140, url: require('resources/images/stickers/taco-clean.png') },
        { width: 280, height: 280, url: require('resources/images/stickers/taco-clean@2x.png') }
        ]
    }
    ]
  },
  'pete': {
    premium: true,
    stickers: [{
      image: 'pete-happy',
      url: require('resources/images/stickers/pete-happy.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/pete-happy.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/pete-happy@2x.png') }
        ]
    }
    , {
      image: 'pete-love',
      url: require('resources/images/stickers/pete-love.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/pete-love.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/pete-love@2x.png') }
      ]
    }
    , {
      image: 'pete-broken',
      url: require('resources/images/stickers/pete-broken.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/pete-broken.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/pete-broken@2x.png') }
        ]
    }
    , {
      image: 'pete-alert',
      url: require('resources/images/stickers/pete-alert.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/pete-alert.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/pete-alert@2x.png') }
        ]
    }
    , {
      image: 'pete-talk',
      url: require('resources/images/stickers/pete-talk.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/pete-talk.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/pete-talk@2x.png') }
      ]
    }
    , {
      image: 'pete-vacation',
      url: require('resources/images/stickers/pete-vacation.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/pete-vacation.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/pete-vacation@2x.png') }
        ]
    }
    , {
      image: 'pete-confused',
      url: require('resources/images/stickers/pete-confused.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/pete-confused.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/pete-confused@2x.png') }
        ]
    }
    , {
      image: 'pete-shipped',
      url: require('resources/images/stickers/pete-shipped.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/pete-shipped.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/pete-shipped@2x.png') }
        ]
    }
    , {
      image: 'pete-busy',
      url: require('resources/images/stickers/pete-busy.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/pete-busy.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/pete-busy@2x.png') }
      ]
    }
    , {
      image: 'pete-completed',
      url: require('resources/images/stickers/pete-completed.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/pete-completed.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/pete-completed@2x.png') }
        ]
    }
    , {
      image: 'pete-space',
      url: require('resources/images/stickers/pete-space.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/pete-space.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/pete-space@2x.png') }
        ]
    }
    , {
      image: 'pete-sketch',
      url: require('resources/images/stickers/pete-sketch.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/pete-sketch.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/pete-sketch@2x.png') }
        ]
    }
    , {
      image: 'pete-ghost',
      url: require('resources/images/stickers/pete-ghost.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/pete-ghost.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/pete-ghost@2x.png') }
        ]
    }
    , {
      image: 'pete-award',
      url: require('resources/images/stickers/pete-award.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/pete-award.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/pete-award@2x.png') }
        ]
    }
    , {
      image: 'pete-music',
      url: require('resources/images/stickers/pete-music.png'),
      scaled: [
        { width: 100, height: 100, url: require('resources/images/stickers/pete-music.png') },
        { width: 200, height: 200, url: require('resources/images/stickers/pete-music@2x.png') }
        ]
    }
    ]
  }
};
